<h2 mat-dialog-title mat-dialog-draggable-title>
  {{ "sign_processing_dialog.title" | translate }}
</h2>

<mat-divider
  *ngIf="
    dataDialog.errorStatus || !dataDialog.signError || !dataDialog.isCancel
  "
></mat-divider>
<mat-progress-bar
  mode="indeterminate"
  *ngIf="
    !dataDialog.errorStatus && !dataDialog.signError && !dataDialog.isCancel
  "
></mat-progress-bar>
<mat-dialog-content>
  <div class="row px-1 py-1">
    <div class="col-12 pt-2">
      <p class="error-text mb-0" *ngIf="dataDialog.errorStatus">
        {{ dataDialog.errorStatus | translate }}
      </p>
      <div class="error-text mb-0" *ngIf="dataDialog.signError" [innerHTML]="dataDialog.signError">
      </div>
      <p
        class="error-text mb-0"
        *ngIf="dataDialog.errorStatus || dataDialog.signError"
      >
        {{ "sign_processing_dialog.note_close_dialog" | translate }}
      </p>
      <p class="text-right">
        {{ "sign_processing_dialog.sign" | translate }}
        {{ renderNumberProcessing() }}/{{ dataDialog.signProcessing.length }}
        file
      </p>
    </div>
    <div class="col-12">
      <table mat-table [dataSource]="dataDialog.signProcessing" matSort>
        <ng-container matColumnDef="stt">
          <th mat-header-cell
            *matHeaderCellDef
            width="80px"
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.index" | translate }}
          </th>
          <td
            *matCellDef="let element; let i = index"
            class="text-center"
          >
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            width="35%"
            >{{ "headertable.name_file" | translate }}
          </th>
          <td *matCellDef="let element; let iRow = index" [attr.rowspan]="element.rowspan"
            [style.display]="element.rowspan === 0 ? 'none'  : ''">
            {{ renderNameFile(element.fileId) }}
          </td>
        </ng-container>
        

        <ng-container matColumnDef="signerName">
          <th mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.signer_name" | translate }}
          </th>
          <td *matCellDef="let element">
            {{ element.signerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="page">
          <th mat-header-cell
            *matHeaderCellDef
            width="10%"
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.page_sign" | translate }}
          </th>
          <td *matCellDef="let element" style="text-transform: capitalize;">
            {{ "sign_processing_dialog.page" | translate }}
            {{ element.pageNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell
            *matHeaderCellDef
            width="10%"
            >{{ "headertable.status" | translate }}
          </th>
          <td *matCellDef="let element" class="text-center">
            <mat-icon style="color: #07736c" *ngIf="element.done">
              done
            </mat-icon>
            <mat-icon *ngIf="!element.done &&
                (dataDialog.errorStatus ||
                  dataDialog.signError ||
                  dataDialog.isCancel || cancelFlow)" style="color: red;">close</mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
        </tr>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mt-2">
  <button
    mat-stroked-button
    color="primary"
    class="mr-3"
    type="button"
    *ngIf="dataDialog.errorStatus || dataDialog.signError"
    mat-dialog-close
  >
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
</mat-dialog-actions>
